'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formPlaceholders = exports.formOverrides = exports.formOptions = exports.formMessages = exports.formLabels = exports.formButtons = undefined;

var _formButtons2 = require('./formButtons');

var _formButtons3 = _interopRequireDefault(_formButtons2);

var _formLabels2 = require('./formLabels');

var _formLabels3 = _interopRequireDefault(_formLabels2);

var _formMessages2 = require('./formMessages');

var _formMessages3 = _interopRequireDefault(_formMessages2);

var _formOptions2 = require('./formOptions');

var _formOptions3 = _interopRequireDefault(_formOptions2);

var _formOverrides2 = require('./formOverrides');

var _formOverrides3 = _interopRequireDefault(_formOverrides2);

var _formPlaceholders2 = require('./formPlaceholders');

var _formPlaceholders3 = _interopRequireDefault(_formPlaceholders2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.formButtons = _formButtons3.default; /**
                                             *  Point of contact for form metadata
                                             *  (includes translations)
                                             *  (formOptions also contains all options for considerably large select inputs (e.g. nationality))
                                             *
                                             *  ie: import { formButtons } from 'metadata/forms';
                                             *
                                             */

exports.formLabels = _formLabels3.default;
exports.formMessages = _formMessages3.default;
exports.formOptions = _formOptions3.default;
exports.formOverrides = _formOverrides3.default;
exports.formPlaceholders = _formPlaceholders3.default;


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/index.js
// module id = 24
// module chunks = 0